import React from 'react';
import { Link } from 'react-router-dom';
import { T } from '../../utils/I18n/I18n'
import './NotFoundPage.scss';
import { Helmet } from "react-helmet-async";

const NotFoundPage = () => {
    return (
        <div className="not-found">
            <Helmet>
                <title>404 - Page Not Found</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <img src="https://s3.emmezeta.hr/falcon/emmezeta-404-uuuups.png" />

            <h2 className="not-found__title"><T id="notFound.title" /></h2>

            <div className="not-found__text">
                <p><T id="notFound.text1" /></p>
                <p><T id="notFound.text2" /></p>
                <p><T id="notFound.text3" /></p>
                <p><T id="notFound.text4" /></p>
            </div>

            <div className="not-found__button">
                <Link to="/"><p><T id="notFound.goBack" /></p></Link>
            </div>

        </div>
    )
}

export default NotFoundPage;
